
import { defineComponent, onMounted, useContext } from '@nuxtjs/composition-api'
import { useLayout } from '@/src/shared/lib/layout'

import { cookiesAccess } from '@/src/shared/lib/cookiesAccess'

import { CabLogo } from '@/src/features/cab'

import { FooterWithLinks } from '@/src/widgets/footer'
import { CookiesAccessTopbar } from '@/src/widgets/modal/cookies-access/toolbar'
import { CookiesAccessModal } from '@/src/widgets/modal/cookies-access/modal'

export default defineComponent({
  components: {
    CabLogo,
    FooterWithLinks,
    CookiesAccessModal,
    CookiesAccessTopbar,
  },
  setup() {
    const { isDesktop } = useLayout()
    const { $modal } = useContext()

    onMounted(() => {
      if (cookiesAccess.needShow) $modal?.open('cookies-access-tollbar')
    })

    return {
      isDesktop,
    }
  },
})
